"use client";

import React from "react";
import { Facebook, House, Instagram, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-primary-foreground/10 animate-pulse rounded" />)}
      </div>;
  }
  return <ul className="space-y-3 text-sm">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-primary-foreground/70 hover:text-primary-foreground transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const socialIcons = [{
    Icon: Facebook,
    label: "Facebook"
  }];
  return <section id="footer" className="bg-primary text-primary-foreground pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-16">
          
          {}
          <div className="space-y-6">
            <p className="text-primary-foreground/70 text-sm leading-relaxed max-w-xs">Dedicated to helping property owners maximize returns and reduce stress through professional, reliable property management services across the greater Orlando and Central Florida area.</p>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="font-semibold text-lg tracking-tight">Quick Links</h3>
            <MenuProvider menu_id="47">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="font-semibold text-lg tracking-tight">Contact Us</h3>
            <ul className="space-y-4 text-sm text-primary-foreground/70">
              <li className="flex items-start gap-3">
                <MapPin className="size-5 shrink-0 text-primary-foreground/50 mt-0.5" />
                <span>6900 Turkey Lake Rd #2-3
Orlando, FL 32819</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-5 shrink-0 text-primary-foreground/50" />
                <span>(407) 298-9777</span>
              </li>
              <li className="flex items-center gap-3">info@4rentorlando.com</li>
            </ul>
          </div>

          {}
          <div className="space-y-8">
            <div className="space-y-4">
              <h3 className="font-semibold text-lg tracking-tight">Connect With Us</h3>
              <div className="flex gap-2">
                {socialIcons.map((social, i) => {
                const Icon = social.Icon;
                const button = <Button data-index={i} variant="ghost" size="icon" className="rounded-full hover:bg-primary-foreground/10 text-primary-foreground hover:text-primary-foreground h-10 w-10" aria-label={social.label}>
                      <Icon className="size-4" />
                    </Button>;
                if (i === 0) {
                  return <Link key={i} data-index={i} to="https://www.facebook.com/RealsourcePropertyManagement" newTab>
                        {button}
                      </Link>;
                }
                return <React.Fragment key={i}>
                      {button}
                    </React.Fragment>;
              })}
              </div>
            </div>
            
            <div className="pt-2">
              <Badge variant="outline" className="border-primary-foreground/20 text-primary-foreground/90 gap-2 py-1.5 px-3 bg-primary-foreground/5 font-normal">
                <House className="size-3.5" />
                Equal Housing Opportunity
              </Badge>
            </div>
          </div>
        </div>

        {}
        <Separator className="bg-primary-foreground/10 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-primary-foreground/60">
          <p>© {new Date().getFullYear()} Realsource Property Management. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="https://noted-bug.10web.cloud/privacy-policy/" className="hover:text-primary-foreground transition-colors duration-200">
              Privacy Policy
            </Link>
            <Link to="https://noted-bug.10web.cloud/terms-conditions/" className="hover:text-primary-foreground transition-colors duration-200">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}